import React from "react";
import "./InfoDetails.css";
import { Link } from "react-router-dom";

const InfoMeasurement = () => {
  return (
    <div className="info-detail">
      <div className="info-hero measurements">
        <h2>Módulo de mediciones</h2>
        <p>
          Centraliza los datos de consumo y permite analizar el uso energético
          en detalle.
        </p>
      </div>

      <section className="info-section">
        <h3>Submódulos</h3>
        <ul>
          <li><b>Consumos generales</b>: visión global.</li>
          <li><b>Detalle de máxímetro</b>: seguimiento de la demanda máxima.</li>
          <li><b>Consumos de confort</b>: análisis de parámetros vinculados al bienestar.</li>
          <li><b>Evolución</b>: tendencias y comparaciones históricas.</li>
        </ul>
      </section>

      <section className="info-flow">
        <h3>Flujo de consulta de mediciones</h3>
        <ol>
            <li>El usuario accede al <b>módulo de mediciones</b>.</li>
            <li>Selecciona el submódulo: consumos, máxímetro, confort o evolución.</li>
            <li>El usuario debe <b>filtrar</b> por planta, grupo primario, parámetro y fecha.</li>
            <li>Los resultados se muestran en <b>gráficos y tablas interactivas</b>.</li>
            <li>El sistema muestra los <b>datos en tiempo real</b> o históricos.</li>
            <li>Puedes elegir el tipo de gráfico, enviarlo al área de reportes o al escritorio para armar un tablero personalizado.</li>
        </ol>
      </section>


      <div className="info-cta">
        <h4>¿Listo para analizar tus consumos?</h4>
        <Link to="/consumption" className="cta-button">
          Explorar mediciones
        </Link>
      </div>
    </div>
  );
};

export default InfoMeasurement;
